<template>
  <div class="container pt-3 px-0 px-sm-3">
    <no-ssr>
      <swiper ref="communitySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, idx) in communities" :key="idx">
          <div :class="item.classname" class="card">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
            <a :href="item.url" :target="item.internal ? '' : '_blank'">{{ cpLang('global.explore') }}</a>
          </div>
        </swiper-slide>
      </swiper>
    </no-ssr>
  </div>
</template>

<script>

export default {
  props: {
    communityCard: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      communities: [],
      communitiesSwiper: null
    }
  },
  computed: {
    swiperOptions() {
      return {
        spaceBetween: 10,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 50
          },
          578: {
            slidesPerView: 2,
            centeredSlides: true,
            spaceBetween: 30
          },
          0: {
            slidesPerView: 1.2,
            centeredSlides: true,
            spaceBetween: 10
            // width: 370
          }
        }
      }
    }
  },
  async mounted() {
    if (this.communityCard) {
      this.communities = await JSON.parse(JSON.stringify(this.communityCard))
    }
    this.communitiesSwiper = this.$refs.communitySwiper.$swiper
    this.communitiesSwiper.slideTo(1, false, true)
  }
}
</script>

<style lang="scss">
.community{
    padding: 40px 0;
    .card{
      width: auto;
      height: 370px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      border: 0;
      color:#fff;
      justify-content: flex-end;
      padding: 20px 30px;
      position: relative;
      overflow: hidden;
      border-radius: 40px;
      box-shadow: 0 5px 10px #00000029;
      &:before{
        content:'';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: linear-gradient(rgba(255, 255, 255, 0 ), rgba(0, 0, 0, 0.8 ));
      }
      h4{
        font-size: 18px;
        font-weight: 600;
        position: relative;
      }
      p{
        font-size: 14px;
        position: relative;
      }
      a{
        font-size: 17px;
        position: relative;
        color:#00CDA7;
      }
    }
    .home-ccard-1{
      background-image: url(/asset/image/photo/ccard-1.png);
    }
    .home-ccard-2{
      background-image: url(/asset/image/photo/ccard-2.png);
    }
    .home-ccard-3{
      background-image: url(/asset/image/photo/ccard-3.png);
    }
  }
</style>
